<div class="ps-1 pb-1 hover-red main-content-width">
  @if (!inSummary && showLeave && sectionId !== 'NBSUM' && !hidecontent
  &&((!isKepro || (!isKepro && sectionId !== 'SACHS')) || (isKepro && sectionId
  !== 'SURCH')) && !hideBackToPrev) {
  <div tabindex="0" class="btn btn-link hover-red ps-0" (click)="onClose()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.875"
      height="15.75"
      viewBox="0 0 16.875 15.75"
    >
      <g
        id="back-outline"
        data-name="⚛️ icons/arrow-back-outline"
        transform="translate(0)"
      >
        <path
          id="back-shape"
          data-name="Combined Shape"
          d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
          transform="translate(0)"
          fill="#174a7c"
        />
      </g>
    </svg>
    <span class="ps-2">{{ backToPreviousPage | globalTranslate }}</span>
  </div>
  } @if (inSummary && showLeave && sectionId !== 'SURCH' && sectionId !==
  'NBSUM') {
  <a tabindex="0" class="btn btn-link hover-red ps-0" (click)="onPrevious()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.875"
      height="15.75"
      viewBox="0 0 16.875 15.75"
    >
      <g
        id="_icons_arrow-back-outline"
        data-name="⚛️ icons/arrow-back-outline"
        transform="translate(0)"
      >
        <path
          id="back_shape"
          data-name="Combined Shape"
          d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
          transform="translate(0)"
          fill="#174a7c"
        />
      </g>
    </svg>
    <span class="ps-2">{{ backToPreviousPage | globalTranslate }}</span>
  </a>
  }
</div>
@if (inSummary && isEbmsDriverFlow && isEbmsOneDhsBanner) {
<div class="main-content-width">
  <nh-alert
    type="warning"
    [isOpen]="inSummary && isEbmsDriverFlow && isEbmsOneDhsBanner"
  >
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
          alt="warning"
        />
      </div>
      <div class="col message">
        <span
          >{{ "EBMS_SUMMARY_BANNER_MESSAGE1" | globalTranslate
          }}{{ ebmsBannertitle | globalTranslate
          }}{{ "EBMS_SUMMARY_BANNER_MESSAGE2" | globalTranslate }}</span
        >
      </div>
    </div>
  </nh-alert>
</div>
}
@if (sectionId === 'SURCH' && isShowNonFfpQncIndicatorNudge) {  
    <nh-alert type="warning" [isOpen]="true">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
          </div>
          <div class="col message">
            <span [innerHTML]="'RMC_IMMIGRATION' | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
  }
<nh-alert type="warning" [isOpen]="this.sectionId === 'SUPSM'">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      @if (!isPreterm) {
      <span>
        <span class="visually-hidden">Alert: </span>
        <span
          [innerHTML]="
            ('REVIEW_CONFIRMATION_PART1' | globalTranslate) +
            ' ' +
            (appKeyWord | globalTranslate) +
            ' ' +
            ('REVIEW_CONFIRMATION_PART2' | globalTranslate)
          "
        ></span>
      </span>
      } @if (isPreterm) {
      <span [innerHTML]="'REVIEW_CONFIRMATION_1' | globalTranslate"> </span>
      }
    </div>
  </div>
</nh-alert>
<nh-alert type="warning" [isOpen]="this.sectionId === 'APSUM'">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span [innerHTML]="'REVIEW_APPEAL_CONFIRMATION' | globalTranslate">
      </span>
    </div>
  </div>
</nh-alert>
<nh-alert type="warning" [isOpen]="this.sectionId === 'MASUM'">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span
        [innerHTML]="'REVIEW_MEDICAL_APPEAL_CONFIRMATION' | globalTranslate"
      >
      </span>
    </div>
  </div>
</nh-alert>
<nh-alert
  type="warning"
  [isOpen]="this.sectionId === 'SURCH' && isShowIncomeReviewRequiredNudge"
>
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt="warning"
      />
    </div>
    <div class="col message">
      <span [innerHTML]="'REVIEW_INCOME_MSG' | globalTranslate"></span>
    </div>
  </div>
</nh-alert>
<nh-alert type="danger" [isOpen]="recordExists">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span [innerHTML]="'MULTIPLE_RECORDS' | globalTranslate"> </span>
    </div>
  </div>
</nh-alert>
<br />
<section class="sections border bg-white p-3 main-content-width">
  <nh-tabset
    [applicationNumber]="applicationNumber"
    [tabs$]="sectionLinks$"
    type="modules"
    (navigate)="onNavigate($event)"
  ></nh-tabset>
  <nh-notifications [messages]="notifications"></nh-notifications>

  @if (inSummary && showRecords() && mode === 'NEW') {
  <section id="records">
    @if (!isSummaryTitle && !appealSummaryAddrep && !imeDetails) {
    <p
      class="static-text"
      [innerHTML]="'OTHER_HEALTH_SUMMARY_STATIC_TEXT1' | globalTranslate"
    ></p>
    } @if (!isSummaryTitle && !appealSummaryAddrep && imeDetails) {
    <p class="section-header">Incurred Medical Expenses Summary</p>
    }
    <hr />
    @if (isSummaryTitle) {
    <p
      class="static-text"
      [innerHTML]="'TAX_SUMMARY_STATIC_TEXT3' | globalTranslate"
    ></p>
    } @if (appealSummaryAddrep) {
    <p
      class="static-text"
      [innerHTML]="'APPEAL_REP_SUMMARY_STATIC1' | globalTranslate"
    ></p>
    } @if (imeDetailsSummaryStatic) {
    <p class="static-text">
      This member has no past submitted incurred medical expenses. To add an
      incurred medical expense for this member, select the Add Another hyperlink
      below.
    </p>
    } @if (!appealSummaryAddrep && !imeDetailsSummaryStatic) {
    <nh-table
      [columns]="columns"
      [sectionId]="this.sectionId"
      [rows]="records"
      [mode]="mode"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
      [moduleStatus]="status"
    >
    </nh-table>
    } @if (showCreate()) {
    <nh-section-info
      [title]="buttonAdd"
      [addKbMedicalBills]="this.addKbMedicalBill"
      (create)="onCreate()"
    ></nh-section-info>
    } @if (sectionId === 'ARPDT') {
    <nh-section-info
      [title]="buttonAdd"
      [hideAddRep]="hideAddRepresentative"
      [addKbMedicalBills]="false"
      [sectionId]="'ARPDT'"
      (create)="onCreate()"
    ></nh-section-info>
    } @if (sectionId === 'IMEDT') {
    <nh-section-info
      [title]="buttonAdd"
      [addKbMedicalBills]="false"
      [sectionId]="'IMEDT'"
      (create)="onCreate()"
    ></nh-section-info>
    }
  </section>
  } @if (inSummary && showRecords() && mode !== 'NEW' && this.sectionId !==
  'SURCH') {
  <section id="records">
    @if (mode === 'REDETERMINATION' && this.translatedLang === 'en') {
    <p class="static-text">
      <span
        class="static-text"
        [innerHTML]="'SUMMARY_STATIC_TEXT1' | globalTranslate"
      ></span>
      <span class="static-text"
        ><b [innerHTML]="'SUMMARY_STATIC_TEXT1_01' | globalTranslate"></b
      ></span>
      <span
        class="static-text"
        [innerHTML]="'SUMMARY_STATIC_TEXT1_02' | globalTranslate"
      ></span>
      <span class="static-text"
        ><b [innerHTML]="'SUMMARY_STATIC_TEXT1_03' | globalTranslate"></b
      ></span>
    </p>
    } @if (mode === 'REDETERMINATION' && this.translatedLang === 'sp') {
    <p class="static-text">
      <span
        class="static-text"
        [innerHTML]="'SUMMARY_STATIC_TEXT1' | globalTranslate"
      ></span>
      <span class="static-text"
        ><b [innerHTML]="'SUMMARY_STATIC_TEXT1_04' | globalTranslate"></b
      ></span>
    </p>
    } @if (mode === 'CHANGE_REPORT') {
    <p [innerHTML]="'RMC_SUMMARY_TEXT' | globalTranslate"></p>
    }
    <nh-review-summary-table
      [mode]="mode"
      [columns]="columns"
      [rows]="records"
      [labels]="labelData"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
      (undo)="onUndo($event)"
      [individuals]="individuals"
      [sectionId]="sectionId"
    ></nh-review-summary-table>
    @if (showCreate() || addAssistingPerson) {
    <nh-section-info
      [addAssisting]="addAssistingPerson"
      [addKbMedicalBills]="this.addKbMedicalBill"
      [sectionId]="sectionId"
      [title]="buttonAdd"
      (create)="onCreate()"
      (edit)="addAssisting()"
    ></nh-section-info>
    }
  </section>
  }

  <ng-container nh-container #container></ng-container>
</section>
<!-- <div class="row pt-1 hover-red comments main-content-width">
      <a *ngIf="showComments && !presumptiveCondition()" class="pl-lg-0 btn btn-link hover-red" (click)="onComment()">
        <span class="pe-2">{{ "ADD_YOUR_COMMENTS" | globalTranslate }} {{ appKeyWord | globalTranslate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 19.49">
          <g id="_icons_create-outline" data-name=" icons create-outline">
            <path id="Combined_Shape-287" data-name="Combined Shape-287" class="cls-1"
              d="M2.63,19.49A2.62,2.62,0,0,1,0,16.91V5.62A2.63,2.63,0,0,1,2.58,3h7.9a.75.75,0,0,1,.75.75.74.74,0,0,1-.74.75H2.63A1.12,1.12,0,0,0,1.5,5.6V16.87A1.12,1.12,0,0,0,2.61,18H13.88A1.12,1.12,0,0,0,15,16.89V8.24a.76.76,0,0,1,.74-.76.75.75,0,0,1,.76.75v8.64a2.62,2.62,0,0,1-2.59,2.62Zm4.92-7.55a.17.17,0,0,1,0-.18l.39-1.17A.42.42,0,0,1,8,10.41L16.47,2a.43.43,0,0,1,.6,0h0l.47.47a.42.42,0,0,1,0,.59L9.09,11.49a.5.5,0,0,1-.19.1L7.74,12H7.68a.21.21,0,0,1-.13-.05ZM18.17,1.85l-.53-.53a.39.39,0,0,1,0-.53h0l.58-.58a.76.76,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-.56.57a.4.4,0,0,1-.54,0h0Z" />
            </g>
          </svg>
        </a>
      </div>-->

<div class="mb-4"></div>

@if (!inSummary) {
<nh-button-bar
  [disableContinue]="disableContinue()"
  [disableSubmit]="disableSubmit()"
  [labelContinue]="labelContinue"
  (continue)="onSave()"
  (leave)="onClose()"
  [showExit]="showSaveAndExit"
  (saveExit)="saveAndExit()"
  [sectionId]="sectionId"
></nh-button-bar>
} @if (inSummary) {
<nh-button-bar
  [disableContinue]="continueDisable()"
  [disableSubmit]="disableSubmit()"
  (continue)="onNext()"
  (leave)="onPrevious()"
  [showExit]="showSaveAndExit"
  (saveExit)="saveAndExit()"
></nh-button-bar>
}